import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export const getUserSettings = objectName => sendRequestWithAuth(
  settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'get_user_settings',
      object_name: objectName
    })
  }
);

export const addUserSettings = (objectName, objectSettings) => sendRequestWithAuth(
  settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'add_user_settings',
      object_name: objectName,
      settings: objectSettings
    })
  }
);



// WEBPACK FOOTER //
// ./src/services/userSettings.js